import React from 'react'
import { createContext } from 'src/util'

const defaultValue = { path: '', disabled: false }

/**
 * A custom context for handling form sections
 */
export default createContext(
  Provider =>
    function FormSectionContext(props) {
      return <Provider {...props} />
    },
  defaultValue
)
